import { store } from '@betacrew/jars-flux'
export const componentKey = "USER_ONBOARDING";

const initialOnboardingData = {
    CompanyName: "",
    CountryCode: "+1",
    PhoneNumber: "",
    BusinessType: "",
    FormCount: "",
    AccountingTypes: [],
}
const { actions } = store.reducerManager.add({
    key: componentKey,
    addedReducers: {
        setOnboardingData: (state, action) => {
            state.onboardingData = {
                ...state.onboardingData,
                ...action.payload,
            };
        },
        setOnboardingFormOptionsData: (state, action) => {
            state.onboardingFormOptionsData = {
                ...state.onboardingFormOptionsData,
                ...action.payload,
            };
        },
        setLoadingState: (state, action) => {
            state.loadingState = action.payload;
        },
        setNavigateNextFromCompanyInfo: (state, action) => {
            state.navigateNextFromCompanyInfo = action.payload;
        },
        setNavigateNextFromCompanySize: (state, action) => {
            state.navigateNextFromCompanySize = action.payload;
        },
        setNavigateNextFromFormQuantity: (state, action) => {
            state.navigateNextFromFormQuantity = action.payload;
        },
        setSelectedCountry: (state, action) => {
            state.selectedCountry = action.payload;
        }
    }, 
    initialReducerState: {
        onboardingData: initialOnboardingData,
        selectedCountry: {
            label: "United States",
            value: "+1",
            code: "US"
        },
        onboardingFormOptionsData: {},
        loadingState: false,
        navigateNextFromCompanyInfo: false,
        navigateNextFromCompanySize: false,
        navigateNextFromFormQuantity: false,
        navigateNextFromAccountingSoftware: false,
    }
});
export const { 
    setOnboardingData, 
    setOnboardingFormOptionsData, 
    setLoadingState, 
    setNavigateNextFromCompanyInfo,
    setNavigateNextFromCompanySize, 
    setNavigateNextFromFormQuantity, 
    setNavigateNextFromAccountingSoftware,
    setSelectedCountry,
} = actions;